import {useState,useEffect} from 'react';
import ChangePassword from './components/ChangePassword';
import FindPasswordForm from "./components/FindPasswordForm";
import {useLocation} from "react-router-dom";


const Password = () => {
    const [isChangePassword, setIsChangePassword] = useState<boolean>(false);
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    useEffect(()=>{
        const tokenVersionId = query.get('tokenVersionId');

        if(tokenVersionId && tokenVersionId !== '') {
            setIsChangePassword(true);
        }
    }, [query]);

    return (
        <div className="flex flex-col max-w-md mx-auto px-4 mt-18">
      <span className="text-gray-900 text-24 font-normal text-center">
        {'비밀번호 찾기'}
      </span>
            {isChangePassword ? (
                <ChangePassword />
            ) : (
                <FindPasswordForm />
            )}
        </div>
    );
};

export default Password;
